import { elements } from '../periodicElements';
import { Link, useNavigate } from 'react-router-dom';
import { useState, useMemo } from 'react';
import { useWindowSize } from '../useWindowSize';
import { handleElementClick, renderElementVideo, renderColumn } from '../FunctionsElements';
import { useTranslation } from 'react-i18next';

export default function GreenChemistry() {
  const [selectedElement, setSelectedElement] = useState(null);
  const windowSize = useWindowSize();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const columnIntervals = [
    [13, 17], [17, 21], [21, 25], [25, 29], [29, 33],
    [33, 37], [37, 41], [41, 45], [45, 49], [49, 53],
  ];

  const renderedColumns = useMemo(() => {
    return columnIntervals.map(([start, end]) =>
      renderColumn(
        elements,
        start,
        end,
        true,
        0, 
        handleElementClick,
        setSelectedElement,
        false,
        windowSize.width < 800,
        false,
        false,
        false,
        windowSize 
      )
    );
  }, [windowSize]); 

  return (
    <section className='overflow-x-hidden'>
      {selectedElement ? (
        <section className="bg-background-secondary min-h-screen flex items-center justify-center p-4 transition-colors duration-300">
          <div className="flex items-center justify-center w-full max-w-4xl">
            {renderElementVideo(selectedElement, setSelectedElement, t, navigate)}
          </div>
        </section>
      ) : (
        <section className="min-h-screen bg-background-secondary w-full pt-28 pb-10 transition-colors duration-300">
          <div className="flex flex-col items-center px-4">
            
            {/* Botão de Voltar */}
            <div className="w-full max-w-fit mb-8 self-center lg:self-auto lg:ml-4">
              <Link to="/TPQVS">
                <button className="bg-primary text-white font-bold py-2 px-6 rounded-md shadow-lg transition-transform transform hover:scale-105 hover:bg-opacity-90">
                  {t("elements.back")}
                </button>
              </Link>
            </div>

            {/* CONTAINER DA TABELA */}
            <div className="w-full overflow-x-auto pb-6 flex justify-center">
             {/* Grid de Elementos*/}
              <div className="grid grid-cols-10 gap-0 ml-8 text-center w-fit min-w-max border-collapse">
                 {renderedColumns}
              </div>
            </div>

            {/* Card de Texto */}
            <div className="w-full lg:w-2/4 p-6 mt-10 bg-surface border border-border-light rounded-lg shadow-lg text-text-primary transition-colors duration-300">
              <h2 className="text-xl sm:text-2xl font-bold text-center mb-4 border-b-2 border-primary text-text-primary pb-2">
                {t("GreenChemistry.name")}
              </h2>
              <p className="text-xs sm:text-sm md:text-base leading-relaxed text-justify text-text-secondary">
                {t("GreenChemistry.discretion")}
              </p>
            </div>

          </div>
        </section>
      )}
    </section>
  );
}